@import '../../../../../../../static/less/variables';

.o-single-subscription {
  margin-bottom: 50px;
}

.spinner-subs {
  width: 95px;
  height: 95px;
}

.warning-icon {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  color: #666666;
}

.o-subscription-dropdown {
  .dropdown-menu {
    > li > a {
      font-size: 15px;
      line-height: 46px;
      color: #546073;
      padding: 3px 45px;
      &:hover {
        background-color: @pipl-blue;
        color: #fff;
      }
    }
  }
}

.filter-select {
  &.col-sm-3 {
    max-width: 22%;
  }
}

.c-filter {
  margin-bottom: 35px;
  .c-search-filter {
    height: 44px;
    background-position: 185px center;
    padding-right: 30px;
    max-width: 220px;
    float: right;
  }
}

.o-subscription-item {
  &:hover {
    .navbar-toggle {
      display: block;
    }
  }
  .open {
    .navbar-toggle {
      display: block;
    }
  }
}

.o-subscription-item__name {
  width: 30%;
  display: inline-block;
  vertical-align: bottom;
}

.o-subscription-item__left {
  width: 10%;
  display: inline-block;
  color: @pipl-dark-gray;
  vertical-align: bottom;
}

.o-subscription-item__user {
  width: 25%;
  display: inline-block;
  color: @pipl-dark-gray;
  vertical-align: bottom;
  padding-right: 30px;
}

.o-subscription-item__period {
  width: 28%;
  display: inline-block;
  color: @pipl-dark-gray;
  padding-left: 30px;
  vertical-align: bottom;
}

.item-expires {
  color: @error-text-color;
}

.o-subscription-item__action {
  width: 4%;
  display: inline-block;
  vertical-align: bottom;
  position: relative;
  text-align: center;
  .o-subscription-dropdown {
    position: absolute;
    top: -25px;
    &.open {
      .navbar-toggle {
        border-bottom: 0;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        z-index: 1040;
      }
    }
    .navbar-toggle {
      margin: 0;
      box-shadow: none;
      background-color: transparent;
      border: 0;
    }

    .dropdown-menu {
      margin-top: -1px;
      border-top-right-radius: 0;
    }
  }
}

.icon-creator(@path; @path_hover) {
  background: url(@path) no-repeat 12px;
  background-size: 20px 20px;
  &:hover {
    background-image: url(@path_hover);
  }
}

.s-icon-edit {
  a {
    .icon-creator(
      '../../../../../../../static/img/profile-grey-min.png' ; '../../../../../../../static/img/profile-min.png'
    );
  }
}

.s-icon-password {
  a {
    .icon-creator('../../../../../../../static/img/lock-grey-min.png' ; '../../../../../../../static/img/lock-min.png');
  }
}

.s-icon-disable {
  a {
    .icon-creator(
      '../../../../../../../static/img/disable-grey-min.png' ; '../../../../../../../static/img/disable-min.png'
    );
  }
}

.s-icon-remove {
  a {
    .icon-creator(
      '../../../../../../../static/img/remove-grey-min.png' ; '../../../../../../../static/img/remove-min.png'
    );
  }
}

@media screen and (max-width: @screen-sm-max) {
  .o-subscription-item__name,
  .o-subscription-item__user,
  .o-subscription-item__left,
  .o-subscription-item__period,
  .o-subscription-item__action {
    margin-bottom: 5px;
    width: 80%;
    padding: 0;
  }

  .o-subscription-item {
    position: relative;
  }

  .c-list {
    li.o-subscription-item:first-child {
      .o-subscription-item__action {
        top: 30px;
      }
    }
  }

  .o-subscription-item__action {
    float: right;
    position: absolute;
    top: 55px;
    right: 30px;
    height: 40px;
    width: 40px;
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/ManagementPanel/routes/Subscriptions/components/Subscription.less